<template>
  <div>
    <swiper ref="leftSlide" :options="swiperOptions">
      <swiper-slide v-for="(item, idx) in swiperImages" :key="idx">
        <img :src="item" alt="" width="100%"/>
      </swiper-slide>
    </swiper>
    <div v-if="pagination" class="prev-btn nav-btn"></div>
    <div v-if="pagination" class="next-btn nav-btn"></div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  name: "SysSwiper",
  components: { swiper, swiperSlide },
  props: {
    pagination: {
      type: Boolean,
      default: false
    },
    swiperImages: {
      type: Array
    }
  },
  data() {
    return {
      swiperOptions: {
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      },
    }
  }
}
</script>

<style scoped>
.nav-btn {
  height: 70px;
  width: 70px;
  position: absolute;
  top: calc(50% - 35px);
  cursor: pointer;
  background-size: 100% 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #707070;
}

.prev-btn {
  left: -40px;
  background-image: url('../../assets/year/icon-left.png');
}

.next-btn {
  right: -40px;
  background-image: url('../../assets/year/icon-right.png');
}
</style>



// WEBPACK FOOTER //
// src/components/common/SysSwiper.vue